import { getLinkDetails } from "@/utils/utilities";
import { globalConstants } from "@/constants/globalConstants";
const MobileNav = ({ mobileNavigation, activeIndex, isOpen, setIsOpen }) => {
  const navItems = mobileNavigation ?? [];
  const mobileNav = navItems?.slice(0, -2);
  const [login, orderNow] = navItems?.slice(-2);
  const loginLinkDetails =login ? getLinkDetails(login) : {};
  const orderNowLinkDetails = orderNow ? getLinkDetails(orderNow) : {};
  const { IMAGES } = globalConstants?.olivegarden || {};
  return (
    <nav
      id="hamburger-nav"
      className={`mobile-nav-slider-wrapper position-fixed bg-white ${isOpen ? 'is-open' : ''}`}
      aria-hidden="true"
    >
      {/* Primary Nav */}
      <ul className="mobile-nav mobile-nav-primary list-unstyled">
        {Array.isArray(mobileNav) &&
          mobileNav?.map((navItem, index) => {
            const { linkTitle, linkUrl, linkTarget, dataLinkInfo, linkID, onClick } = getLinkDetails(navItem);
            if (!linkTitle || !linkUrl || index >= activeIndex) return null;

            return (
              <li className="mobile-nav-item" key={navItem.uid} onClick={() => setIsOpen(prev => !prev)}>
                <a
                  href={linkUrl}
                  target={linkTarget}
                  id={linkID}
                  className="mobile-nav-link trackContent"
                  data-link-info={dataLinkInfo}
                  // onclick={onClick}
                 
                >
                  <div className="d-flex justify-content-between">
                    <span className="">{linkTitle}</span>
                    <img src={IMAGES?.CHEVRON_RIGHT?.IMAGE_URL} alt={IMAGES?.CHEVRON_RIGHT?.IMAGE_ALT} />
                  </div>
                </a>
              </li>
            );
          })}
      </ul>

      {/* Secondary Nav */}
      <ul className="mobile-nav mobile-nav-secondary list-unstyled">
        {Array.isArray(mobileNav) &&
          mobileNav?.map((navItem, index) => {
            const { linkTitle, linkUrl, linkTarget, dataLinkInfo, aria_describedby } = getLinkDetails(navItem);
            if (!linkTitle || !linkUrl || index < activeIndex) return null;
            return (
              <li key={navItem?.uid} className="mobile-nav-item" onClick={() => setIsOpen(prev => !prev)}>
                <a
                  href={linkUrl}
                  target={linkTarget}
                 
                  className="mobile-nav-link trackContent"
                  aria-describedby={aria_describedby}
                  data-link-info={dataLinkInfo}
                >
                  {linkTitle}
                </a>
              </li>
            );
          })}
      </ul>

      <div className="px-4 d-flex flex-column justify-content-center">
        <div id="responsiveMobileLoginLink" className="mb-3 d-flex justify-content-center login-wrap__mobile">
          <a
            className="btn btn-outline-og btn-large  trackContent"
            href={loginLinkDetails?.linkUrl}
            target={loginLinkDetails?.linkTarget}
            data-link-info={loginLinkDetails?.dataLinkInfo}
            aria-label={loginLinkDetails?.ariaLabel}
           
            onClick={() => setIsOpen(prev => !prev)}
          >
            {loginLinkDetails?.linkTitle}
          </a>
        </div>


        <a
          className="btn btn-large btn-green-900-og trackContent"
          href={orderNowLinkDetails?.linkUrl}
          target={orderNowLinkDetails?.linkTarget}
          aria-label={orderNowLinkDetails?.ariaLabel}
          data-link-info={orderNowLinkDetails?.dataLinkInfo}
         
          onClick={() => setIsOpen(prev => !prev)}
        >
          {orderNowLinkDetails?.linkTitle}
        </a>
      </div>
    </nav>

  );
};

export default MobileNav;